module.exports = __webpack_public_path__ + "static/media/view4.a7593493.jpg";